import { Center, Flex, Spinner, Text } from '@chakra-ui/react'
import { motion } from 'framer-motion'

export const VideoProcessing = () => {
  return (
    <Center
      bg='black'
      color='white'
      height='100%'
      left={0}
      pos='absolute'
      top={0}
      width='100%'
      zIndex={1}
    >
      <Flex alignItems='center' direction='column' justifyContent='center'>
        <Spinner
          animate={{ opacity: 1 }}
          as={motion.div}
          color='white'
          emptyColor='gray.500'
          exit={{ opacity: 0 }}
          initial={{ opacity: 0 }}
          mb='10px'
          size='lg'
          thickness='4px'
        />
        <Text fontSize='20px' fontWeight={500}>
          Video clip processing...
        </Text>
      </Flex>
    </Center>
  )
}
